import React, { useEffect, useState } from "react";
import styles from "./../style.module.css";
import {useTranslation} from "react-i18next";
import {useStores} from "../../../../../hooks";
import {observer} from "mobx-react";
import {
    FormControl,
    Paper,
} from "../../../../../common/components/libs";
import style from "../style.module.css";
import {FormControlLabel, InputLabel, MenuItem, OutlinedInput, Select, Switch} from "@material-ui/core";
import { MenuItemWorkingScheduleDay,
    MenuItemWorkingScheduleDaySlot
} from "../../../../../services/menu/models";
import {changeEventHandlerDecorator} from "../../../../../common/libs";

interface ItemWorkingSlotProps {
    item: MenuItemWorkingScheduleDaySlot,
    daySchedule: MenuItemWorkingScheduleDay,
    updateValue: (t: MenuItemWorkingScheduleDay) => void;
}


const ItemWorkingSlot = observer((props: ItemWorkingSlotProps) => {
    const {t} = useTranslation(["general", "menu"]);
    const {item, daySchedule} = props;
    const slots = daySchedule.slots;
    const slot = slots[0];

    const time = [
        {hour: "00", min: "00"}, {hour: "00", min: "15"}, {hour: "00", min: "30"}, {hour: "00", min: "45"}, {hour: "00", min: "59"},
        {hour: "01", min: "00"}, {hour: "01", min: "15"}, {hour: "01", min: "30"}, {hour: "01", min: "45"}, {hour: "01", min: "59"},
        {hour: "02", min: "00"}, {hour: "02", min: "15"}, {hour: "02", min: "30"}, {hour: "02", min: "45"}, {hour: "02", min: "59"},
        {hour: "03", min: "00"}, {hour: "03", min: "15"}, {hour: "03", min: "30"}, {hour: "03", min: "45"}, {hour: "03", min: "59"},
        {hour: "04", min: "00"}, {hour: "04", min: "15"}, {hour: "04", min: "30"}, {hour: "04", min: "45"}, {hour: "04", min: "59"},
        {hour: "05", min: "00"}, {hour: "05", min: "15"}, {hour: "05", min: "30"}, {hour: "05", min: "45"}, {hour: "05", min: "59"},
        {hour: "06", min: "06"}, {hour: "06", min: "15"}, {hour: "06", min: "30"}, {hour: "06", min: "45"}, {hour: "06", min: "59"},
        {hour: "07", min: "00"}, {hour: "07", min: "15"}, {hour: "07", min: "30"}, {hour: "07", min: "45"}, {hour: "07", min: "59"},
        {hour: "08", min: "00"}, {hour: "08", min: "15"}, {hour: "08", min: "30"}, {hour: "08", min: "45"}, {hour: "08", min: "59"},
        {hour: "09", min: "00"}, {hour: "09", min: "15"}, {hour: "09", min: "30"}, {hour: "09", min: "45"}, {hour: "09", min: "59"},
        {hour: "10", min: "00"}, {hour: "10", min: "15"}, {hour: "10", min: "30"}, {hour: "10", min: "45"}, {hour: "10", min: "59"},
        {hour: "11", min: "00"}, {hour: "11", min: "15"}, {hour: "11", min: "30"}, {hour: "11", min: "45"}, {hour: "11", min: "59"},
        {hour: "12", min: "00"}, {hour: "12", min: "15"}, {hour: "12", min: "30"}, {hour: "12", min: "45"}, {hour: "12", min: "59"},
        {hour: "13", min: "00"}, {hour: "13", min: "15"}, {hour: "13", min: "30"}, {hour: "13", min: "45"}, {hour: "13", min: "59"},
        {hour: "14", min: "00"}, {hour: "14", min: "15"}, {hour: "14", min: "30"}, {hour: "14", min: "45"}, {hour: "14", min: "59"},
        {hour: "15", min: "00"}, {hour: "15", min: "15"}, {hour: "15", min: "30"}, {hour: "15", min: "45"}, {hour: "15", min: "59"},
        {hour: "16", min: "00"}, {hour: "16", min: "15"}, {hour: "16", min: "30"}, {hour: "16", min: "45"}, {hour: "16", min: "59"},
        {hour: "17", min: "00"}, {hour: "17", min: "15"}, {hour: "17", min: "30"}, {hour: "17", min: "45"}, {hour: "17", min: "59"},
        {hour: "18", min: "00"}, {hour: "18", min: "15"}, {hour: "18", min: "30"}, {hour: "18", min: "45"}, {hour: "18", min: "59"},
        {hour: "19", min: "00"}, {hour: "19", min: "15"}, {hour: "19", min: "30"}, {hour: "19", min: "45"}, {hour: "19", min: "59"},
        {hour: "20", min: "00"}, {hour: "20", min: "15"}, {hour: "20", min: "30"}, {hour: "20", min: "45"}, {hour: "20", min: "59"},
        {hour: "21", min: "00"}, {hour: "21", min: "15"}, {hour: "21", min: "30"}, {hour: "21", min: "45"}, {hour: "21", min: "59"},
        {hour: "22", min: "00"}, {hour: "22", min: "15"}, {hour: "22", min: "30"}, {hour: "22", min: "45"}, {hour: "22", min: "59"},
        {hour: "23", min: "00"}, {hour: "23", min: "15"}, {hour: "23", min: "30"}, {hour: "23", min: "45"}, {hour: "23", min: "59"},

    ]


    return (<>
            <div className={style.time}>
                <FormControl fullWidth variant="outlined" className={style.selectItem}>
                    <InputLabel htmlFor="menuItemSchedule">
                        {t("menu:showFrom")}
                    </InputLabel>
                    <Select
                        value={`${slot.fromHour}:${slot.fromMinute}`}
                        onChange={changeEventHandlerDecorator(function (workingSchedule: string): void {
                            props.updateValue({
                                ...daySchedule,
                                slots: [
                                    {
                                        fromHour: parseInt(workingSchedule.split(":")[0]),
                                        fromMinute: parseInt(workingSchedule.split(":")[1]),
                                        toHour: item.toHour,
                                        toMinute: item.toMinute
                                    }
                                ]
                            });
                        })
                        }
                        input={<OutlinedInput
                            labelWidth={80}
                        />}
                    >
                        {
                            time.map(index => {
                                const hour = parseInt(index.hour);
                                const min = parseInt(index.min);
                                return (
                                    <MenuItem value={`${hour}:${min}`} key={`${hour}:${min}`}>
                                        {index.hour} : {index.min}
                                    </MenuItem>
                                )
                            })
                        }

                    </Select>
                </FormControl>
                <FormControl fullWidth variant="outlined" className={style.selectItem}>
                    <InputLabel htmlFor="menuItemSchedule">
                        {t("menu:showTo")}
                    </InputLabel>
                    <Select
                        value={`${slot.toHour}:${slot.toMinute}`}
                        onChange={changeEventHandlerDecorator(function (workingSchedule: string): void {
                            props.updateValue({
                                ...daySchedule,
                                slots: [
                                    {
                                        fromHour: item.fromHour,
                                        fromMinute: item.fromMinute,
                                        toHour: parseInt(workingSchedule.split(":")[0]),
                                        toMinute: parseInt(workingSchedule.split(":")[1])
                                    }
                                ]
                            });
                        })
                        }
                        input={<OutlinedInput
                            labelWidth={80}
                        />}
                    >
                        {
                            time.map(index => {
                                const hour = parseInt(index.hour);
                                const min = parseInt(index.min);
                                return (
                                    <MenuItem value={`${hour}:${min}`} key={`${hour}:${min}`}>
                                        {index.hour} : {index.min}
                                    </MenuItem>
                                )
                            })
                        }

                    </Select>
                </FormControl>
            </div>

        </>
    )
})
const MenuItemSchedule = () => {
    const {t} = useTranslation(["general", "menu"], {useSuspense: false});
    const {menuStore, generalStore} = useStores();

    const locale = generalStore.locale.id;

    return (
        <Paper p={5}>
            <div className={style.menuItemSchedule}>
                <div className={style.dayTimeItem}>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={menuStore.itemWorkingSchedule.monday.isEnabled}
                                    onChange={(event) => {
                                        menuStore.setMondayItemSchedule( {
                                            ...menuStore.itemWorkingSchedule.monday,
                                            isEnabled: event.target.checked
                                        });
                                    }}
                                    value={menuStore.itemWorkingSchedule.monday.isEnabled}
                                />
                            }
                            label= {t("menu:orderSettingsPage.monday")}
                        />
                    </FormControl>
                    {
                        menuStore.itemWorkingSchedule.monday.isEnabled && menuStore.itemWorkingSchedule.monday.slots.map(item => {
                            return <ItemWorkingSlot
                                item={item}
                                daySchedule={menuStore.itemWorkingSchedule.monday}
                                updateValue={menuStore.setMondayItemSchedule.bind(menuStore)}
                            />
                        })
                    }
                </div>
                <div className={style.dayTimeItem}>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={menuStore.itemWorkingSchedule.tuesday.isEnabled}
                                    onChange={(event) => {
                                        menuStore.setTuesdayItemSchedule({
                                            ...menuStore.itemWorkingSchedule.tuesday,
                                            isEnabled: event.target.checked
                                        });
                                    }}
                                    value={menuStore.itemWorkingSchedule.tuesday.isEnabled}
                                />
                            }
                            label={t("menu:orderSettingsPage.tuesday")}
                        />
                    </FormControl>
                    {
                        menuStore.itemWorkingSchedule.tuesday.isEnabled && menuStore.itemWorkingSchedule.tuesday.slots.map(item => {
                            return <ItemWorkingSlot
                                item={item}
                                daySchedule={menuStore.itemWorkingSchedule.tuesday}
                                updateValue={menuStore.setTuesdayItemSchedule.bind(menuStore)}
                            />
                        })
                    }
                </div>
                <div className={style.dayTimeItem}>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={menuStore.itemWorkingSchedule.wednesday.isEnabled}
                                    onChange={(event) => {
                                        menuStore.setWednesdayItemSchedule({
                                            ...menuStore.itemWorkingSchedule.wednesday,
                                            isEnabled: event.target.checked
                                        });
                                    }}
                                    value={menuStore.itemWorkingSchedule.wednesday.isEnabled}
                                />
                            }
                            label={t("menu:orderSettingsPage.wednesday")}
                        />
                    </FormControl>
                    {
                        menuStore.itemWorkingSchedule.wednesday.isEnabled && menuStore.itemWorkingSchedule.wednesday.slots.map(item => {
                            return <ItemWorkingSlot
                                item={item}
                                daySchedule={menuStore.itemWorkingSchedule.wednesday}
                                updateValue={menuStore.setWednesdayItemSchedule.bind(menuStore)}
                            />
                        })
                    }
                </div>
                <div className={style.dayTimeItem}>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={menuStore.itemWorkingSchedule.thursday.isEnabled}
                                    onChange={(event) => {
                                        menuStore.setThursdayItemSchedule({
                                            ...menuStore.itemWorkingSchedule.thursday,
                                            isEnabled: event.target.checked
                                        });
                                    }}
                                    value={menuStore.itemWorkingSchedule.thursday.isEnabled}
                                />
                            }
                            label={t("menu:orderSettingsPage.thursday")}
                        />
                    </FormControl>
                    {
                        menuStore.itemWorkingSchedule.thursday.isEnabled && menuStore.itemWorkingSchedule.thursday.slots.map(item => {
                            return <ItemWorkingSlot
                                item={item}
                                daySchedule={menuStore.itemWorkingSchedule.thursday}
                                updateValue={menuStore.setThursdayItemSchedule.bind(menuStore)}
                            />
                        })
                    }
                </div>
                <div className={style.dayTimeItem}>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={menuStore.itemWorkingSchedule.friday.isEnabled}
                                    onChange={(event) => {
                                        menuStore.setFridayItemSchedule({
                                            ...menuStore.itemWorkingSchedule.friday,
                                            isEnabled: event.target.checked
                                        });
                                    }}
                                    value={menuStore.itemWorkingSchedule.friday.isEnabled}
                                />
                            }
                            label={t("menu:orderSettingsPage.friday")}
                        />
                    </FormControl>
                    {
                        menuStore.itemWorkingSchedule.friday.isEnabled && menuStore.itemWorkingSchedule.friday.slots.map(item => {
                            return <ItemWorkingSlot
                                item={item}
                                daySchedule={menuStore.itemWorkingSchedule.friday}
                                updateValue={menuStore.setFridayItemSchedule.bind(menuStore)}
                            />
                        })
                    }
                </div>
                <div className={style.dayTimeItem}>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={menuStore.itemWorkingSchedule.saturday.isEnabled}
                                    onChange={(event) => {
                                        menuStore.setSaturdayItemSchedule({
                                            ...menuStore.itemWorkingSchedule.saturday,
                                            isEnabled: event.target.checked
                                        });
                                    }}
                                    value={menuStore.itemWorkingSchedule.saturday.isEnabled}
                                />
                            }
                            label={t("menu:orderSettingsPage.saturday")}
                        />
                    </FormControl>
                    {
                        menuStore.itemWorkingSchedule.saturday.isEnabled && menuStore.itemWorkingSchedule.saturday.slots.map(item => {
                            return <ItemWorkingSlot
                                item={item}
                                daySchedule={menuStore.itemWorkingSchedule.saturday}
                                updateValue={menuStore.setSaturdayItemSchedule.bind(menuStore)}
                            />
                        })
                    }
                </div>
                <div className={style.dayTimeItem}>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={menuStore.itemWorkingSchedule.sunday.isEnabled}
                                    onChange={(event) => {
                                        menuStore.setSundayItemSchedule({
                                            ...menuStore.itemWorkingSchedule.sunday,
                                            isEnabled: event.target.checked
                                        });
                                    }}
                                    value={menuStore.itemWorkingSchedule.sunday.isEnabled}
                                />
                            }
                            label={t("menu:orderSettingsPage.sunday")}
                        />
                    </FormControl>
                    {
                        menuStore.itemWorkingSchedule.sunday.isEnabled && menuStore.itemWorkingSchedule.sunday.slots.map(item => {
                            return <ItemWorkingSlot
                                item={item}
                                daySchedule={menuStore.itemWorkingSchedule.sunday}
                                updateValue={menuStore.setSundayItemSchedule.bind(menuStore)}
                            />
                        })
                    }
                </div>
            </div>

        </Paper>

    )
}

export default observer(MenuItemSchedule)